import { useEffect, useState } from "react";
import {
  CheckCircle2,
  Loader2,
  Clock3,
} from "lucide-react";

import { socket } from "../socket";

const statusConfig = {
  UPLOADING: {
    color: "bg-blue-500",
    text: "text-blue-700",
    bg: "bg-blue-50",
    icon: Loader2,
  },

  PROCESSING: {
    color: "bg-amber-500",
    text: "text-amber-700",
    bg: "bg-amber-50",
    icon: Clock3,
  },

  COMPLETED: {
    color: "bg-green-500",
    text: "text-green-700",
    bg: "bg-green-50",
    icon: CheckCircle2,
  },
};

const UploadProgress = ({
  uploadId,
  title = "Processing",
  onProgress
}) => {
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("UPLOADING");
  const [isStarted, setStarted] = useState(false);
  const [isCompleted, setCompleted] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!uploadId) return;

    socket.emit("join-upload", uploadId);

    const handleProgress = (data) => {
      if (data.status === "STARTED") {
        setStarted(true);
        setMessage("");
      }

      if (data.status === "COMPLETED") {
        setCompleted(true);
        setMessage("");
      }

      setProgress(data.progress || 0);
      setStatus(data.status);
      setMessage(data.message);
      onProgress(data.status)
    };

    socket.on("progress", handleProgress);

    return () => {
      socket.off("progress", handleProgress);
    };
  }, [uploadId]);

  if (!isStarted || isCompleted) {
    return null;
  }

  const current =
    statusConfig[status] || statusConfig.UPLOADING;

  const Icon = current.icon;

  return (
  isStarted &&
  !isCompleted && (
    <div className="mt-3  rounded-lg border border-blue-100 bg-blue-50 px-3 py-2">

      {/* Header */}

      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">

          <div className="h-2 w-2 rounded-full bg-blue-500 animate-pulse" />

          <span className="text-xs font-medium text-slate-700">
            {uploadId?.includes("source")
              ? "Source File"
              : "Target File"}
          </span>

        </div>

        <span className="text-xs font-semibold text-blue-700">
          {progress}%
        </span>
      </div>

      {/* Progress */}

      <div className="h-1.5 w-full rounded-full bg-blue-100 overflow-hidden">
        <div
          className="h-full rounded-full bg-blue-600 transition-all duration-300"
          style={{
            width: `${progress}%`,
          }}
        />
      </div>

      {/* Status */}

      <div className="mt-3 flex justify-between text-[11px] text-slate-500">
        <span>{status}</span>
        {status=='FAILED'? <span className="text-xs font-semibold text-red-700">
          {message}
        </span>:<span className="text-xs font-semibold text-blue-700">
          {message}
        </span>}
        <span>
          {progress < 100
            ? "Running..."
            : "Completed"}
        </span>
      </div>

    </div>
  )
)
};

export default UploadProgress;